export default __webpack_public_path__ + "locales/ko-KR/Settings.json?hash=58f0517487c342ff905166e996f174bd";